export default (theme) => ({
    darkBorderTop: {
        borderTop: "2px solid black",
    },
    background: {
        backgroundColor: "#a7a7a7",
    },
});
